var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankStatements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.43 198.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_fac28e347b3bd344cf06d19cbbe3698e005a5aaa22fd65f114d8a1437b9ed906",
    x1: 86.84,
    y1: 41.06,
    x2: 117.68,
    y2: 41.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M52.05 23.56h81.31a8.91 8.91 0 019 8.72v103l-81.31.14V49.29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M61.08 49.4H43v-17a9 9 0 0118 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_0_fac28e347b3bd344cf06d19cbbe3698e005a5aaa22fd65f114d8a1437b9ed906)",
    d: "M88.09 45.49h28.34l-14.11-8.87-14.23 8.87zM93.32 62.55V45.78"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M79.77 75.76h-7.48"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_0_fac28e347b3bd344cf06d19cbbe3698e005a5aaa22fd65f114d8a1437b9ed906)",
    d: "M102.53 62.55V45.78M89.55 63.13h26.3M111.95 62.55V45.78"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M85.46 75.76h45.52"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M79.77 83.11h-7.48"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M85.46 83.12h45.52"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M79.77 90.95h-7.48"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M85.46 90.96h45.52"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M79.77 98.31h-7.48"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M85.46 98.31h45.52"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M79.77 105.66h-7.48"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M85.46 105.66h45.52"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M79.77 113.5h-7.48"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M85.46 113.5h45.52"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M79.77 120.85h-7.48"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M85.46 120.85h45.52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankStatements);
export default __webpack_public_path__ + "static/media/bankStatements.9e7dc2027c199403859a9d93aa94939b.svg";
export { ForwardRef as ReactComponent };